import React from 'react'

function Contact() {
  return (
    <>
      <br></br>
  
      <div className="card card-compact w-88 bg-base-100 shadow-xl mt-50 ml-100 mb-8">
        <center><b><h2 className="card-title center">My Profiles and Contacts!</h2></b></center>
        <br></br>
            <div className="card-body">
              <ul>

                <li> <p className='text-xl'>• LinkedIn - <a href="https://www.linkedin.com/in/rhythm-batra-4322b0173/" target='false'>
                  Rhythm Batra</a></p></li>
                  <br></br>
                <li><p className='text-xl'>• Mail me @ batrarhythm99@gmail.com
                  </p></li>
                  <br></br>
                  <li> <p className='text-xl'>• Leetcode - <a href="https://leetcode.com/rhythmbatra08/" target='false'>
                  rhythmbatra08</a></p></li>
                  <br></br>
                  <li> <p className='text-xl'>• Geeks For Geeks - <a href="https://auth.geeksforgeeks.org/user/rhythmbatra08/practice/" target='false'>
                  rhythmbatra08</a></p></li>
              
              </ul>
            </div>
            </div>





    </>
  )
}

export default Contact